import { getHelpTarget } from "@/help/getHelpTarget";
export const waitForHelpTarget = (helpId, options = {}) => {
    const { intervalMs = 100, timeoutMs = 8000, signal } = options;
    return new Promise((resolve) => {
        const startedAt = Date.now();
        let timeoutId = null;
        const cleanup = () => {
            if (timeoutId)
                clearTimeout(timeoutId);
            signal?.removeEventListener("abort", onAbort);
        };
        const onAbort = () => {
            cleanup();
            resolve(null);
        };
        const check = () => {
            if (signal?.aborted) {
                onAbort();
                return;
            }
            const target = getHelpTarget(helpId);
            if (target) {
                cleanup();
                resolve(target);
                return;
            }
            if (Date.now() - startedAt >= timeoutMs) {
                cleanup();
                resolve(null);
                return;
            }
            timeoutId = setTimeout(check, intervalMs);
        };
        signal?.addEventListener("abort", onAbort, { once: true });
        check();
    });
};
